import { ComponentsProps, ComponentsOverrides, ComponentsVariants, Theme, typographyClasses } from '@mui/material';

export const MuiDialog: {
    defaultProps?: ComponentsProps['MuiDialog'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiDialog'];
    variants?: ComponentsVariants['MuiDialog'];
} = {
    defaultProps: {
        fullWidth: true,
        maxWidth: 'md',
        scroll: 'body',
    },
    styleOverrides: {
        paper: (props) => ({
            borderRadius: props.theme.borderRadius(props.theme.tokens.borderRadius.md),
            padding: props.theme.spacing(props.theme.tokens.spacing.xl),
        }),
        paperFullScreen: (props) => ({
            borderRadius: props.theme.borderRadius(props.theme.tokens.borderRadius.none),
        }),
    },
};

export const MuiDialogTitle: {
    defaultProps?: ComponentsProps['MuiDialogTitle'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiDialogTitle'];
    variants?: ComponentsVariants['MuiDialogTitle'];
} = {
    styleOverrides: {
        root: (props) => ({
            padding: props.theme.spacing(props.theme.tokens.spacing.none),
        }),
    },
};

export const MuiDialogActions: {
    defaultProps?: ComponentsProps['MuiDialogActions'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiDialogActions'];
    variants?: ComponentsVariants['MuiDialogActions'];
} = {
    styleOverrides: {
        root: (props) => ({
            padding: props.theme.spacing(
                props.theme.tokens.spacing.xl,
                props.theme.tokens.spacing.none,
                props.theme.tokens.spacing.none
            ),
        }),
    },
};

export const MuiDialogContent: {
    defaultProps?: ComponentsProps['MuiDialogContent'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiDialogContent'];
    variants?: ComponentsVariants['MuiDialogContent'];
} = {
    styleOverrides: {
        root: (props) => ({
            padding: props.theme.spacing(props.theme.tokens.spacing.none),
        }),
    },
};

export const MuiDialogContentText: {
    defaultProps?: ComponentsProps['MuiDialogContentText'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiDialogContentText'];
    variants?: ComponentsVariants['MuiDialogContentText'];
} = {
    styleOverrides: {
        root: (props) => ({
            [`&:not(.${typographyClasses.body1})`]: {
                color: props.theme.palette.text.primary,
            },
        }),
    },
};
